module.exports = __webpack_public_path__ + "static/media/tax-product.22750784.svg";